<!--
* Add "other" input values/props (check from select/input/etc)
* Cleanup
* Rest of styling(?)
  * Hover/focus atleast
-->
<template>
  <div class="wrapper">
    <label
      :class="['checkbox', disabled === true ? 'checkbox--disabled' : '']"
      role="button"
      aria-labelledby="checkbox"
      tabindex="0"
      @click="updateValue"
      @keydown.enter="updateValue"
    >
      <div :class="['checkbox__button', output === true ? 'checkbox__button--active' : '', disabled === true ? 'checkbox__button--disabled' : '']">
        <div :class="['checkbox__icon', output === true ? 'checkbox__icon--selected' : '']">
          <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M0 11.522l1.578-1.626 7.734 4.619 13.335-12.526 1.353 1.354-14 18.646z"/></svg>
        </div>
      </div>

      <div :class="['checkbox__label', disabled === true ? 'checkbox__label--disabled' : '']">
        {{ label }}
      </div>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      output: this.value
    }
  },
  methods: {
    updateValue () {
      if (this.disabled === false) {
        this.output = !this.output
        this.$emit('valueChanged', this.output)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

.wrapper {
  @include font('content--md', $white, 0.9);
  position: relative;
  user-select: none;

  @media screen and (min-width: $breakpointLg) {
    @include font('content--lg', $white, 0.9);
  }

  .checkbox {
    display: flex;
    align-items: center;
    cursor: pointer;

    &--disabled {
      cursor: not-allowed;
    }

    &__button {
      background-color: rgba($bg-1, 0);
      transition: background-color 0.2s ease;
      border: 2px solid rgba($white, 0.7);
      border-radius: 3px;

      &--disabled {
        border: 2px solid rgba($white, 0.3);
      }

      &--active {
        border: 2px solid $blue;
        background-color: $blue;
      }
    }

    &__icon {
      width: 16px;
      height: 16px;
      padding: 2px;
      fill: rgba($white, 0);
      transition: fill 0.1s ease-out;

      @media screen and (min-width: $breakpointLg) {
        width: 18px;
        height: 18px;
      }

      &--selected {
        fill: $white;
      }
    }

    &__label {
      margin-left: 12px;

      &--disabled {
        color: rgba($white, 0.5);
      }
    }
  }
}
</style>
